import {AbstractEditPage} from "../../../framework/entity/edit/edit-page/abstract-edit-page";
import {ChangeDetectorRef, Component} from "@angular/core";
import {provideEntityModel} from "@fedeltapointofsale/data-client";
import {ScreenLayoutEntityModel} from "../screen-layout-entity.model";
import {SellableIconService} from "../../../catalogue/sellable/sellable-icon.service";
import {PreparationModifierValuesSearchModel} from "../../../catalogue/preparation-modifier/preparation-modifier-values-search-model.service";
import {SizeGroupValuesSearchModel} from "../../../catalogue/size-group/size-group-values-search.model";
import {SellableSearchModel} from "../../../catalogue/sellable/sellable-search.model";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";

@Component({
    selector: "screen-layout-edit-page",
    templateUrl: "./screen-layout-edit-page.component.html",
    providers: [provideEntityModel(ScreenLayoutEntityModel),
        SellableIconService,
        PreparationModifierValuesSearchModel,
        SizeGroupValuesSearchModel,
        SellableSearchModel]
})
export class ScreenLayoutEditPageComponent extends AbstractEditPage {
    constructor(public model: ScreenLayoutEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(changeDetectorRef, responsiveService);
    }
}
